export default __webpack_public_path__ + "static/elekta-c60189491665fdb20c3138374f686245.svg";